import { combineReducers } from 'redux'
import misc from './misc'
import employees from './employees'

export default combineReducers({
  misc,
  employees,
})
